'use client'

import { useTranslations } from 'next-intl'

import LogoIconSvg from '@/assets/logo_icon.svg'
import { cn } from '@/lib/utils/cn'

interface VoiceModelBadgeProps {
  className?: string
}

/**
 * 当前模型状态展示（区块行样式）
 * 用于 Voice Design / Voice Clone 表单卡片内，置于首个区块上方。
 * 左侧标题字号与各表单区块标题保持一致（text-[14px] font-semibold），
 * 右侧无边框胶囊：前置 Digen logo + 当前语音模型名（例如 Real Voice 1.0）。
 */
export const VoiceModelBadge = ({ className }: VoiceModelBadgeProps) => {
  const t = useTranslations('voice.model')

  return (
    <div className={cn('flex items-center justify-start', className)}>
      <div className="inline-flex shrink-0 items-center gap-2 rounded-full bg-white/[0.04] px-3 py-1.5">
        <LogoIconSvg className="size-4 shrink-0" />
        <span className="text-[12px] font-semibold text-[var(--text-1)]">{t('name')}</span>
      </div>
    </div>
  )
}
